import { useI18nDirection } from '@/hooks/useI18nDirection.ts';

export function OnboardingStep({
  image,
  title,
  description,
}: {
  image: string;
  title: string;
  description: string;
}) {
  const directionDivRef = useI18nDirection<HTMLDivElement>();

  return (
    <div className="flex flex-col items-center gap-12 md:gap-20">
      <img src={image} alt="" className="size-[128px] md:size-[180px] lg:size-[200px]" />
      <div className="flex flex-col gap-4 sm:gap-6 max-w-xl text-center" ref={directionDivRef}>
        <h1 className="text-3xl md:text-4xl lg:text-5xl text-balance">{title}</h1>
        <p className="text-lg md:text-xl lg:text-2xl text-balance">{description}</p>
      </div>
    </div>
  );
}
